const locale = require('./aboutUmsModal.i18n.json');

/*@ngInject*/
const AboutUmsModalController = function ($rootScope, $scope, coreConstant, options, appTypeConfigurationModel, browserUtil) {

    $scope.i18n = locale;

    $scope.viewModel = {
        svnRevision: options.revNumber,
        browserType: browserUtil.getBrowserInfo(),
        umVersionNumber: options.umVersionNumber,
        versionNumberLabel: options.versionNumberLabel,
        message: locale.copyright
    };

    function init() {
        const consoleType = appTypeConfigurationModel.getConsoleType();

        switch (consoleType) {
            case coreConstant.authorization.CONSOLE_TYPE_UM:
            case coreConstant.authorization.CONSOLE_TYPE_UM_AGENT:
                $scope.viewModel.title = $scope.i18n.titleUM;
                $scope.viewModel.versionNumberLabel = $scope.i18n.umVersionNumber;
                break;

            case coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO:
                $scope.viewModel.title = $scope.i18n.titleUMStudio;
                $scope.viewModel.versionNumberLabel = $scope.i18n.umStudioVersionNumber;
                break;
        }
    }

    $scope.onConfirm = function () {
        $scope.$close();
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.$on(coreConstant.event.MODAL_CLOSING, () => {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('gw-um-header')
    .controller('aboutUmsModalController', AboutUmsModalController);
